import { useEffect } from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectAuthData } from '../../../pages/PageAuth/selectors/authSelectors';
import { IAuthData } from '../../../pages/PageAuth/types/authTypes';
import { IRootReducer } from '../../../reducers/rootReducer';
import { makeSelectGtmContainerId, makeSelectIsGtmEnabled } from '../../app/appSelectors';
import { onInitGTMOperation } from './GTMOperations';

interface IGoogleTagManagerProps {
    gtmContainerId: string | null;
    isGtmEnabled: boolean | null;
    authData: IAuthData;
}

const GoogleTagManager = (props: IGoogleTagManagerProps) => {
    useEffect(() => {
        if (props.isGtmEnabled) {
            const script = document.createElement('script');
            script.innerHTML = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n' +
                'new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\n' +
                'j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n' +
                '\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n' +
                '})(window,document,\'script\',\'dataLayer\',\'' + props.gtmContainerId + '\');';
            document.head.appendChild(script);
            // push to dataLayer init information
            onInitGTMOperation(props.authData.user.susrId, props.authData.user.bisId);
        }
    }, [props.isGtmEnabled]);

    return null;
};

const mapStateToProps = () => createStructuredSelector<IRootReducer, IGoogleTagManagerProps>({
    gtmContainerId: makeSelectGtmContainerId(),
    isGtmEnabled: makeSelectIsGtmEnabled(),
    authData: makeSelectAuthData(),
});

export default connect(mapStateToProps)(GoogleTagManager);

